var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVideoUnmuted(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.583 8.375c0-.437.355-.792.792-.792h8.708c.438 0 .792.355.792.792v7.917a.792.792 0 0 1-.792.791H5.375a.792.792 0 0 1-.792-.791V8.375Zm11.875 2.42v-2.42A2.375 2.375 0 0 0 14.083 6H5.375A2.375 2.375 0 0 0 3 8.375v7.917a2.375 2.375 0 0 0 2.375 2.375h8.708a2.375 2.375 0 0 0 2.375-2.375v-2.42l4.29 3.064A.792.792 0 0 0 22 16.292V8.375a.792.792 0 0 0-1.252-.644l-4.29 3.064Zm3.959 3.958-3.388-2.42 3.388-2.42v4.84Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoUnmuted);
export default __webpack_public_path__ + "static/media/video-unmuted.e345752a915d3a2f5afcc2e8b39cc760.svg";
export { ForwardRef as ReactComponent };